import React from "react";
import { YardDateField } from "../../../components/common/YardDateField";
import { useHistory } from "react-router-dom";

import { isEmpty } from "lodash";

import { Grid, Typography, useMediaQuery } from "@material-ui/core";

import {
  ArrayField,
  BooleanField,
  Datagrid,
  FunctionField,
  Labeled,
  Loading,
  NumberField,
  SelectField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
  useShowController,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { NotesTabShow } from "../../../components/common/NotesTab";
import { FileField } from "../../../components/common/FileField";
import {
  CustomField,
  CustomFieldsMobile,
} from "../../../components/common/CustomFields";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";
import { ShowButton } from "../../../components/common/ShowButton";
import { SendPOSDialogButton } from "../../../components/common/SendPOSDialogButton";

import {
  AclType,
  CarrierType,
  CarrierTypes,
  OutboundStatus,
} from "../../../utils/constants";
import {
  getHoursMinutesDuration,
  getYardCalendarDaysInclusive,
} from "../../../utils/dateUtils";
import {
  deepRedirect,
  getBackPath,
  quantityRenderer,
} from "../../../utils/utils";
import { isAuthorized } from "../../../utils/appUtils";
import {
  calcTotalQuantity,
  getInfoBubble,
  getPOSEmailSubject,
  handleSendPOS,
  InventoryItemsEditGridInput,
} from "../../../managerApp/resources/outboundShipments/OutboundUtils";

import { useOperatingAccount } from "../../../managerApp/resources/accounts/AccountUtils";
import { OutboundAdviceAside } from "./OutboundAdviceAside";

const ShipmentSetupTab = ({ gteMedium, ...props }) => {
  const { record } = props;
  const CarrierTypesReversed = [].concat(CarrierTypes).reverse();

  return (
    <Grid container direction="column" spacing={1}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} sm={6} md={4}>
          <Labeled label="PO Number">
            <TextField source="poNumber" />
          </Labeled>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Labeled label="Inventory Transfer">
            <TextField source="transfer" />
          </Labeled>
        </Grid>
      </Grid>
      {isEmpty(record.transfer) ? (
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12} sm={6} md={4}>
            <Labeled label="Carrier Type">
              <SelectField
                source="carrierType"
                choices={CarrierTypesReversed}
              />
            </Labeled>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Labeled label="Carrier Name">
              <TextField source="carrierName" />
            </Labeled>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Labeled
              label={
                record.carrierType === CarrierType.RAIL
                  ? "Railcar Number"
                  : "Trailer Number"
              }
            >
              <TextField source="railCarNumber" />
            </Labeled>
          </Grid>
          {record.carrierType === CarrierType.TRUCK && (
            <Grid item xs={12} sm={6} md={4}>
              <Labeled label="Pickup Number">
                <TextField source="pickupNumber" />
              </Labeled>
            </Grid>
          )}
          {record?.carrierType === CarrierType.TRUCK && (
            <Grid item xs={12} md={4}>
              <Labeled label="Must Tarp?">
                <BooleanField source="mustTarp" />
              </Labeled>
            </Grid>
          )}
          {record.shipTo && (
            <Grid item xs={12}>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={12}>
                  <Typography
                    gutterBottom
                    variant="overline"
                    color="textSecondary"
                  >
                    Consignee Address
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Labeled label="Destination Name">
                    <TextField source="shipTo.name" />
                  </Labeled>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Labeled label="Street Address">
                    <TextField source="shipTo.street" />
                  </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Labeled label="CIty">
                    <TextField source="shipTo.city" />
                  </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Labeled label="State">
                    <TextField source="shipTo.state" />
                  </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Labeled label="Zip Code">
                    <TextField source="shipTo.zipCode" />
                  </Labeled>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Labeled label="Country">
                    <TextField source="shipTo.country" />
                  </Labeled>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Labeled label="Special Instructions">
              <TextField source="instructions" />
            </Labeled>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <Typography gutterBottom variant="overline" color="textSecondary">
              Destination Account
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Labeled label="To Account">
              <TextField source="transferToAccountName" />
            </Labeled>
          </Grid>
        </Grid>
      )}
      <CustomFieldsMobile
        recordFields={record.customFields}
        accountFields={record.account.outboundCustomFields}
        width={4}
      />
      {gteMedium && (
        <Grid container direction="row" spacing={2}>
          <Grid item xs={6}>
            <Labeled label="ATTACHMENTS">
              <FileField
                source="attachments"
                src="src"
                title="title"
                target="_blank"
              />
            </Labeled>
          </Grid>
          <Grid item xs={6}>
            <Labeled label="BOL FILE">
              <FileField
                source="bolFile"
                src="src"
                title="title"
                target="_blank"
              />
            </Labeled>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export const PickListTab = ({ operatingAccount, ...props }) => {
  const { history, backPath, record } = props;

  const accountFields =
    (operatingAccount || record.account)?.inventoryCustomFields?.length > 0
      ? (operatingAccount || record.account).inventoryCustomFields
      : [];
  const customColumns = [];
  const customGridFields = accountFields
    ? accountFields.map((field, index) => {
        customColumns.push(field.name);
        return (
          <CustomField
            source={`customFields[${index}]`}
            field={field}
            label={field.name}
            sortable={true}
          />
        );
      })
    : [];

  const openShipmentLineItem = (jsonRecord) => {
    const jsonObject = JSON.parse(jsonRecord);
    const toPath = `/inventories/${jsonObject.inventoryId}/show`;
    deepRedirect(history, toPath, backPath);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <ArrayField
          source="shipmentLineItems.items"
          basePath="/inventories"
          fullWidth
        >
          <CustomizableDatagrid
            label="OUTBOUND INVENTORY"
            hasBulkActions={false}
            rowClick={openShipmentLineItem}
            expand={<InventoryItemsEditGridInput />}
            storageProp={`OutboundShipmentLineItems_${record.account?.id}_$large`}
            defaultColumns={[
              "inventory.productName",
              "lotNumber",
              "inventory.quantityOnHand",
              "inventory.quantityCommitted",
              "inventory.quantityAvaiable",
              "totalQuantityToPick",
              "inventory.inventoryUOM",
              ...customColumns,
            ]}
          >
            {[
              <FunctionField
                source="inventory.productName"
                label="Product Name"
                sortable={true}
                render={(record) =>
                  record?.inventory && (
                    <>
                      {record.inventory.productName}{" "}
                      {getInfoBubble(record, record)}{" "}
                    </>
                  )
                }
              />,
              <TextField source="lotNumber" label="Lot Number" />,
              <TextField source="inventory.poNumber" label="PO Number" />,
              <NumberField
                source="inventory.quantityOnHand"
                label="Qty. On Hand"
              />,
              <NumberField
                source="inventory.quantityCommitted"
                label="Qty. Committed"
              />,
              <FunctionField
                source="inventory.quantityAvaiable"
                label="Qty. Available"
                sortable={false}
                render={(record) =>
                  record &&
                  `${
                    record.inventory?.quantityOnHand -
                    record.inventory?.quantityCommitted
                  }`
                }
              />,
              <NumberField
                source="totalQuantityToPick"
                label="Qty. Outbound"
              />,
              <TextField source="inventory.inventoryUOM" label="UOM" />,
              ...customGridFields,
              <ShowButton {...props} idSource="inventoryId" />,
            ]}
          </CustomizableDatagrid>
        </ArrayField>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="overline" color="textSecondary">
          Total Load
        </Typography>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={6} md={3}>
            <Labeled label="Total Quantity">
              <FunctionField
                render={(record) =>
                  quantityRenderer(calcTotalQuantity(record), record.totalUOM)
                }
              />
            </Labeled>
          </Grid>
          <Grid item xs={6} md={3}>
            <Labeled label="Net Weight">
              <FunctionField
                render={(record) =>
                  quantityRenderer(record.netWeight, record.weightUnits)
                }
              />
            </Labeled>
          </Grid>
        </Grid>
      </Grid>

      {!record?.skipInvoice && isAuthorized(AclType.INVOICES_VIEW) && (
        <Grid item xs={12}>
          <fieldset>
            <legend>
              <Typography variant="overline" color="textSecondary">
                Billing
              </Typography>
            </legend>
            <Grid item container xs={12} spacing={6}>
              <Grid item xs={12} md={6}>
                <Labeled label="Manual Charges" fullWidth>
                  <ArrayField source="manualCharges.items" fullWidth>
                    <Datagrid bulkActionButtons={false}>
                      <FunctionField
                        label="Service"
                        render={(mc) => mc?.chargeRule?.service?.name || ""}
                      />
                      <NumberField source="quantity" label="Quantity" />
                      <TextField source="chargeRule.billingUOM" label="UOM" />
                    </Datagrid>
                  </ArrayField>
                </Labeled>
              </Grid>
            </Grid>
          </fieldset>
        </Grid>
      )}
    </Grid>
  );
};

const grossRender = (record) => {
  if (
    record.tareWeight !== null &&
    record.tareWeight >= 0 &&
    record.ladenWeight >= 0
  ) {
    return `${record.ladenWeight - record.tareWeight} ${
      record.weightUnits ? record.weightUnits : record.scaleWeightUnits
    }`;
  } else
    return `0 ${
      record.weightUnits ? record.weightUnits : record.scaleWeightUnits
    }`;
};

const DispatchTab = ({ record, ...props }) => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item container direction="row">
        <Grid item xs={12} md={4}>
          <Labeled label="Time Scheduled">
            <YardDateField source="scheduledDateTime" showTime />
          </Labeled>
        </Grid>
        {record.carrierType === CarrierType.TRUCK &&
          isEmpty(record.transfer) && (
            <Grid item xs={12} md={4}>
              <Labeled label="Carrier Name">
                <TextField source="carrierName" />
              </Labeled>
            </Grid>
          )}
        {record.carrierType === CarrierType.TRUCK &&
          isEmpty(record.transfer) && (
            <Grid item xs={12} md={4}>
              <Labeled label="Trailer Number">
                <TextField source="railCarNumber" />
              </Labeled>
            </Grid>
          )}
      </Grid>
      <Grid item container direction="row">
        <Grid item xs={12} md={4}>
          <Labeled label="Time Placed">
            {/* arrivalDateTime fallback: records placed before the placement
                backfill carry the placed time there. */}
            <YardDateField
              source="placementDateTime"
              fallbackSource="arrivalDateTime"
              showTime
            />
          </Labeled>
        </Grid>
        {record.carrierType === CarrierType.TRUCK &&
          isEmpty(record.transfer) && (
            <>
              <Grid item xs={12} md={4}>
                <Labeled label="Tare Weight">
                  <FunctionField
                    render={(record) =>
                      quantityRenderer(
                        record.tareWeight,
                        record.scaleWeightUnits,
                      )
                    }
                  />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={4}>
                <Labeled label="Laden Weight">
                  <FunctionField
                    render={(record) =>
                      quantityRenderer(
                        record.ladenWeight,
                        record.scaleWeightUnits,
                      )
                    }
                  />
                </Labeled>
              </Grid>
            </>
          )}
      </Grid>
      <Grid item container direction="row">
        <Grid item xs={12} md={4}>
          <Labeled label="Load Start Time">
            <YardDateField source="startDateTime" showTime />
          </Labeled>
        </Grid>
        {record.carrierType === CarrierType.TRUCK &&
          isEmpty(record.transfer) && (
            <>
              <Grid item xs={12} md={4}>
                <Labeled label="Net Weight">
                  <FunctionField
                    render={(record) =>
                      quantityRenderer(
                        record.netWeight || 0,
                        record.scaleWeightUnits,
                      )
                    }
                  />
                </Labeled>
              </Grid>
              <Grid item xs={12} md={4}>
                <Labeled label="Gross Weight">
                  <FunctionField render={grossRender} />
                </Labeled>
              </Grid>
            </>
          )}
      </Grid>
      <Grid item container direction="row">
        <Grid item xs={12} md={4}>
          <Labeled label="Load End Time">
            <YardDateField source="endDateTime" showTime />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={4}>
          <Labeled label="Total Load Time">
            <FunctionField
              render={(record) =>
                getHoursMinutesDuration(
                  "",
                  record.startDateTime,
                  record.endDateTime,
                )
              }
            />
          </Labeled>
        </Grid>
      </Grid>
      <Grid item container direction="row">
        <Grid item xs={12} md={4}>
          <Labeled label="Time Released">
            <YardDateField source="departureDateTime" showTime />
          </Labeled>
        </Grid>
        <Grid item xs={12} md={4}>
          <Labeled label="Cycle Time">
            <FunctionField
              render={(record) =>
                getHoursMinutesDuration(
                  "",
                  record.arrivalDateTime || record.placementDateTime,
                  record.departureDateTime,
                )
              }
            />
          </Labeled>
        </Grid>
      </Grid>
      {record.carrierType === CarrierType.RAIL && (
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12} md={4}>
            <Labeled label="Time Collected">
              <YardDateField source="collectedDateTime" showTime />
            </Labeled>
          </Grid>
          {record.collectedDateTime && (
            <Grid item xs={12} md={4}>
              {/* Placed through pulled, both days counted. */}
              <Labeled label="Storage Days">
                <FunctionField
                  render={(record) =>
                    `: ${
                      getYardCalendarDaysInclusive(
                        record.placementDateTime || record.arrivalDateTime,
                        record.collectedDateTime,
                      ) ?? 0
                    }`
                  }
                />
              </Labeled>
            </Grid>
          )}
        </Grid>
      )}
      {record?.account?.trackOutboundSeals &&
        record.carrierName !== "TRANSFER" && (
          <Grid item xs={12} md={6}>
            <Labeled label="Seals" fullWidth>
              <ArrayField source="seals.items">
                <Datagrid>
                  <BooleanField source="validated" />
                  <TextField source="barcode" />
                  <TextField source="discribtion" />
                </Datagrid>
              </ArrayField>
            </Labeled>
          </Grid>
        )}
    </Grid>
  );
};

const ShowActions = ({ data, backPath, ...props }) => (
  <TopToolbar>
    {data && !data.status?.startsWith(OutboundStatus.ADVICE_ALL) && (
      <SendPOSDialogButton
        label="SEND"
        title="Send POS"
        record={data}
        email={data.account?.posEmail}
        subjectDefault={getPOSEmailSubject(data)}
        enclosePhotosDefault={data.account?.posPhotos}
        encloseDocsDefault={data.account?.posAttachments}
        handleSend={handleSendPOS}
      />
    )}
    <BackButton {...props} backPath={backPath} />
  </TopToolbar>
);

export const OutboundShow = (props) => {
  const { record } = useShowController(props);
  const history = useHistory();
  const gteMedium = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const backPath = getBackPath(props);
  const [operatingAccount] = useOperatingAccount(record);

  if (!record?.account) return <Loading />;
  return (
    <Show
      {...props}
      title={<ForceTitle title="View Outbound" />}
      actions={<ShowActions {...props} backPath={backPath} />}
      aside={
        <OutboundAdviceAside {...props} history={history} backPath={backPath} />
      }
    >
      <TabbedShowLayout>
        <Tab label="Outbound Setup">
          <ShipmentSetupTab {...props} gteMedium={gteMedium} />
        </Tab>
        <Tab label="Pick List">
          <PickListTab
            {...props}
            history={history}
            backPath={backPath}
            operatingAccount={operatingAccount}
          />
        </Tab>
        <Tab label="Dispatch">
          <DispatchTab {...props} />
        </Tab>
        <Tab label="Notes">
          <NotesTabShow {...props} hidePrivate={true} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
